export const generateQueryString = (
  params: Record<string, string | number | (string | number)[] | undefined>,
) => {
  return `?${Object.keys(params)
    .map((key) => {
      const value = params[key];
      if (value !== undefined) {
        if (Array.isArray(value)) {
          return value
            .flatMap((item) =>
              item
                ? [
                    `${encodeURIComponent(key)}=${encodeURIComponent(
                      item.toString(),
                    )}`,
                  ]
                : [],
            )
            .join('&');
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
      }
      return '';
    })
    .filter(Boolean)
    .join('&')}`;
};
